import React, { useState, useEffect } from 'react';

import {Grid} from '@material-ui/core';
import SingleDish from "../../components/Dishes/SIngleDish";

const PublicProfileDishes = (props) => {
  const [dishes, setDishes] = useState([]);

  useEffect(() => {
    if (props.dishesList) {
      setDishes(props.dishesList.map(dish => {
        return (
          <SingleDish dish={dish} cart={null} handleClick={props.handleClick} key={dish.id} viewAsDiner={false} isPublicProfile={true} />
        );
      }));
    }
  }, [props.dishesList]);

  return (
    <Grid className="dish-container" container>
      <div className="dish-conatiner-row">
        {dishes}
      </div>
    </Grid>
  );
};

export default PublicProfileDishes;
